import { Module } from 'vuex'
import { mutations } from '@/store/modules/account/mutations'
import { actions } from '@/store/modules/account/actions'
import RootState from '@/store/RootState'
import { getters } from '@/store/modules/account/getters'
import UserState from "@/store/modules/account/UserState"

export const account: Module<UserState, RootState> = {
  namespaced: true,
  state: new UserState(),
  mutations,
  actions,
  getters
}
